import { Typography } from "@mui/material";
import moment from "moment/moment";
import type { ProductConfiguration } from "@/types/social.ts";

interface HeaderProps {
  product: ProductConfiguration;
  date: string;
  classes: any;
}

export const Header = ({ product, date, classes }: HeaderProps) => {
  return (
    <>
      <Typography
        variant="h6"
        sx={{
          fontSize: {
            xs: "18px",
            md: "22px",
          },
          color: "#223647",
        }}
      >
        {product.name}
      </Typography>
      <Typography variant="h6" className={classes.dfpMetricsValue}>
        {moment(date).format("DD.MM.YYYY")}
      </Typography>
    </>
  );
};
